import React from 'react';
import GiftCardTheCard from './GiftCardTheCard';
import Button from '../../elements/buttons/Button';

const GiftCard = () =>(
    
    <>
        <section className="giftCards">
            <div className="wrap">
                <div className="row middle-xs">
                    <div className="col-xs-12 col-sm-6">
                        <GiftCardTheCard />
                    </div>
                    <div className="col-xs-12 col-sm-6">
                        <h2 className="titles">SORPRéNDELOS CON UN <br />
                        <span>REGALO DIFERENTE</span></h2>
                        <p>En esta era digital también cambiaron los regalos. Con XD Neo, podés darle a esa persona, la posibilidad de ver el mejor contenido, cuando y donde quiera.</p>
                        <div>
                            <Button copy="Descubre las Gift Cards" link="/" className="button-primary" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
)

export default GiftCard;